import React from 'react';
import { observer } from 'mobx-react';
import { Button, Container, View } from '../../..../../core/components/Index';
import useAsyncEffect from 'use-async-effect';
import { useSearchParams } from 'react-router-dom'
import { AppPermissions } from '../../..../../core/services/AppPermissions';
import { Appl } from '../../..../../core/Appl';

const LogoutView: React.FC = observer(() => {
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = searchParams.get('mode')?.toLowerCase();
  const from = searchParams.get('from')?.toLowerCase();
  useAsyncEffect(async () => {
    // await AuthContext.instance.signOutAsync();

  }, []);

  return (
    <>
      <View id="LogoutView" pageTitle="Logout" authKey={AppPermissions.PublicAccess} showMenuBar={false} container={false}>
        <Container>
          <div className="p-10  mx-auto">
            <div className="bg-white rounded-xl mb-4 py-20 px-10 text-center ">

              {mode === "session" && from === "idletimer" && <>
                <h1 className="text-2xl md:text-3xl font-semibold mb-4">You've Been Logged Out Due to Inactivity</h1>
                <p>
                  To help protect your personal information, your session has ended after a period of inactivity.<br /><br />Don't worry-your progress has been saved.<br />When you're ready, you can log back in to continue.<br /><br />
                </p>
                <Button title="Return to MySCERS" rounded onClick={() => window.location.href = `${Appl.Setting.MyScersPortalUrl}`} />
              </>
              }
              {mode === "session" && (from === "docusign" || from === "member") && <>
                <h1 className="text-2xl md:text-3xl font-semibold mb-4">You've Been Logged Out Due to Inactivity</h1>
                <p>
                  To help protect your personal information, your session has ended after a period of inactivity.<br /><br />Don't worry-your progress has been saved.<br />When you're ready, you can log back in to continue your retirement application.<br /><br />
                </p>
                <Button title="Return to MySCERS" rounded onClick={() => window.location.href = `${Appl.Setting.MyScersPortalUrl}`} />
              </>
              }
            </div>
          </div>
        </Container>
      </View>
    </>
  );
});

export default LogoutView;
